/** Shared loader for the Square Web Payments SDK (card entry). */

const SQUARE_JS = {
  production: "https://web.squarecdn.com/v1/square.js",
  sandbox: "https://sandbox.web.squarecdn.com/v1/square.js",
};

export const loadSquareJs = (env) =>
  new Promise((resolve, reject) => {
    if (window.Square) return resolve();
    const existing = document.querySelector("script[data-square-sdk]");
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("Square SDK failed to load")));
      return;
    }
    const s = document.createElement("script");
    s.src = SQUARE_JS[env] || SQUARE_JS.production;
    s.async = true;
    s.dataset.squareSdk = "1";
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Square SDK failed to load"));
    document.head.appendChild(s);
  });
